import { USERS } from "@/constants";

export function isBetaTester(email: string) {
  const betaTestersEmails = USERS.BETA_TESTERS.map(u => u.toLocaleLowerCase());
  return betaTestersEmails.includes(email.toLocaleLowerCase());
}
